/*
 * Catalogue for the Camcom One flow (route "/").
 *
 * Source: CamcomOne-UI-draft-04.html (sales-kit-dev/src/Claude outputs/).
 * Every user-facing string here is an i18next KEY under the co_ prefix — the text lives in
 * public/locales/*.json, in all 11 locales.
 *
 * EXCEPTION: `brand` is a literal, never a key. The sub-brand lockups
 * (Vernier / Vigil / Modulus by CamCom) stay English in every locale by design.
 */

/*
 * Live-demo targets. Only PATHS live in the catalogue; the host comes from
 * REACT_APP_DEMO_BASE so pointing the kit at a different environment is one build-time
 * change rather than an edit per link (AGENTS.md: no hardcoded base URLs in source).
 */
export const DEMO_BASE =
  process.env.REACT_APP_DEMO_BASE || "https://trinetra.internal.camcom.ai";
export const demoUrl = (path) => `${DEMO_BASE}${path}`;

export const VERTICALS = [
  {
    "key": "insurance",
    "capture": true,
    "brand": "Vernier by CamCom",
    "name": "co_v_insurance_name",
    "line": "co_v_insurance_line",
    "ucs": [
      {
        "key": "motor",
        "short": "co_uc_insurance_motor_short",
        "name": "co_uc_insurance_motor_name",
        "d": {
          "demo": {
            "s": "ready",
            "capture": [
              "/en/camcomsales-new/",
              "/en/camcomsales-dev/"
            ]
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "ready"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "build"
          }
        }
      },
      {
        "key": "property",
        "short": "co_uc_insurance_property_short",
        "name": "co_uc_insurance_property_name",
        "d": {
          "demo": {
            "s": "ready",
            "url": "/en/camcomsales-prpt"
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "build"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "build"
          }
        }
      }
    ]
  },
  {
    "key": "aftermarket",
    "capture": true,
    "newv": true,
    "brand": "Vernier by CamCom",
    "name": "co_v_aftermarket_name",
    "sub": "co_v_aftermarket_sub",
    "line": "co_v_aftermarket_line",
    "ucs": [
      {
        "key": "all",
        "short": "co_uc_aftermarket_all_short",
        "name": "co_uc_aftermarket_all_name",
        "d": {
          "demo": {
            "s": "ready",
            "capture": [
              "/en/camcomsales-new/",
              "/en/camcomsales-dev/"
            ]
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "build"
          },
          "case": {
            "s": "build"
          }
        }
      }
    ]
  },
  {
    "key": "safety",
    "brand": "Vigil by CamCom",
    "name": "co_v_safety_name",
    "line": "co_v_safety_line",
    "ucs": [
      {
        "key": "city",
        "short": "co_uc_safety_city_short",
        "name": "co_uc_safety_city_name",
        "d": {
          "demo": {
            "s": "ready",
            "url": "/en/public-safety"
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "ready"
          },
          "ppt": {
            "s": "ready",
            "n": "co_note_safety_city_ppt"
          },
          "case": {
            "s": "ready"
          }
        }
      },
      {
        "key": "construction",
        "short": "co_uc_safety_construction_short",
        "name": "co_uc_safety_construction_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "na"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "ready"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "na"
          }
        }
      },
      {
        "key": "road",
        "short": "co_uc_safety_road_short",
        "name": "co_uc_safety_road_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "update",
            "n": "co_note_safety_road_dash"
          },
          "vid": {
            "s": "build"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "update"
          }
        }
      }
    ]
  },
  {
    "key": "hospitality",
    "brand": "Vigil by CamCom",
    "name": "co_v_hospitality_name",
    "line": "co_v_hospitality_line",
    "ucs": [
      {
        "key": "hotel",
        "short": "co_uc_hospitality_hotel_short",
        "name": "co_uc_hospitality_hotel_name",
        "d": {
          "demo": {
            "s": "tbd",
            "n": "co_note_hosp_hotel_demo"
          },
          "dash": {
            "s": "na"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "ready"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "na"
          }
        }
      },
      {
        "key": "airports",
        "short": "co_uc_hospitality_airports_short",
        "name": "co_uc_hospitality_airports_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "na"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "build"
          },
          "case": {
            "s": "na"
          }
        }
      }
    ]
  },
  {
    "key": "oem",
    "newv": true,
    "brand": "Modulus by CamCom",
    "name": "co_v_oem_name",
    "line": "co_v_oem_line",
    "ucs": [
      {
        "key": "paint",
        "short": "co_uc_oem_paint_short",
        "name": "co_uc_oem_paint_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "build"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "ready"
          }
        }
      },
      {
        "key": "eol",
        "short": "co_uc_oem_eol_short",
        "name": "co_uc_oem_eol_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "build"
          },
          "case": {
            "s": "build"
          }
        }
      },
      {
        "key": "component",
        "short": "co_uc_oem_component_short",
        "name": "co_uc_oem_component_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "build"
          },
          "vid": {
            "s": "build"
          },
          "broc": {
            "s": "build"
          },
          "ppt": {
            "s": "build"
          },
          "case": {
            "s": "build"
          }
        }
      }
    ]
  },
  {
    "key": "proof",
    "brand": "CamCom",
    "name": "co_v_proof_name",
    "line": "co_v_proof_line",
    "ucs": [
      {
        "key": "voices",
        "short": "co_uc_proof_voices_short",
        "name": "co_uc_proof_voices_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "na"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "na"
          },
          "ppt": {
            "s": "na"
          },
          "case": {
            "s": "na"
          }
        }
      },
      {
        "key": "sectors",
        "short": "co_uc_proof_sectors_short",
        "name": "co_uc_proof_sectors_name",
        "d": {
          "demo": {
            "s": "na"
          },
          "dash": {
            "s": "na"
          },
          "vid": {
            "s": "ready"
          },
          "broc": {
            "s": "na"
          },
          "ppt": {
            "s": "ready"
          },
          "case": {
            "s": "na"
          }
        }
      }
    ]
  }
];

export const FILES = {
  "insurance|motor|vid": [
    {
      "t": "co_f_insurance_motor_vid_0_t",
      "m": "co_f_insurance_motor_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/Claims%20and%20TriNetra/Claims%20Video.mp4"
    },
    {
      "t": "co_f_insurance_motor_vid_1_t",
      "m": "co_f_insurance_motor_vid_1_m",
      "src": "/video/local/Zoho%20WorkDrive/Claims%20and%20TriNetra/Insurance%20Explainer%20Video_trinetra%20aiand%204.01.03%E2%80%AFPM.mp4"
    },
    {
      "t": "co_f_insurance_motor_vid_2_t",
      "m": "co_f_insurance_motor_vid_2_m",
      "src": "/video/local/Zoho%20WorkDrive/Claims%20and%20TriNetra/TriNetra%20%26%20PI%20Portal.mp4"
    }
  ],
  "insurance|motor|broc": [
    {
      "t": "co_f_insurance_motor_broc_0_t",
      "m": "co_f_insurance_motor_broc_0_m",
      "src": "/pdf%20docs/Insurance/Decks/Insurance_Brochure.pdf"
    },
    {
      "t": "co_f_insurance_motor_broc_1_t",
      "m": "co_f_insurance_motor_broc_1_m",
      "src": "/pdf%20docs/Insurance/Decks/Digital_Passport_Capability_Dossier.pdf"
    }
  ],
  "insurance|motor|ppt": [
    {
      "t": "co_f_insurance_motor_ppt_0_t",
      "m": "co_f_insurance_motor_ppt_0_m",
      "src": "/pdf%20docs/Insurance/Decks/PnC_4W_Aftermarket%20Insurance.pdf"
    }
  ],
  "insurance|motor|case": [
    {
      "t": "co_f_insurance_motor_case_0_t",
      "m": "co_f_insurance_motor_case_0_m"
    }
  ],
  "insurance|property|vid": [
    {
      "t": "co_f_insurance_property_vid_0_t",
      "m": "co_f_insurance_property_vid_0_m"
    },
    {
      "t": "co_f_insurance_property_vid_1_t",
      "m": "co_f_insurance_property_vid_1_m"
    }
  ],
  "insurance|property|broc": [
    {
      "t": "co_f_insurance_property_broc_0_t",
      "m": "co_f_insurance_property_broc_0_m"
    }
  ],
  "insurance|property|ppt": [
    {
      "t": "co_f_insurance_property_ppt_0_t",
      "m": "co_f_insurance_property_ppt_0_m",
      "src": "/pdf%20docs/Insurance/Decks/Property%20Insurance..pdf"
    },
    {
      "t": "co_f_insurance_property_ppt_1_t",
      "m": "co_f_insurance_property_ppt_1_m",
      "src": "/pdf%20docs/Insurance/Decks/Facilities%20Building%20Insurance.pdf"
    },
    {
      "t": "co_f_insurance_property_ppt_2_t",
      "m": "co_f_insurance_property_ppt_2_m",
      "src": "/pdf%20docs/Insurance/Decks/Retail_Shops_Insurance.pdf"
    },
    {
      "t": "co_f_insurance_property_ppt_3_t",
      "m": "co_f_insurance_property_ppt_3_m",
      "src": "/pdf%20docs/Insurance/Decks/Warehouse%20Insurance.pdf"
    }
  ],
  "insurance|property|case": [
    {
      "t": "co_f_insurance_property_case_0_t",
      "m": "co_f_insurance_property_case_0_m"
    }
  ],
  "safety|city|vid": [
    {
      "t": "co_f_safety_city_vid_0_t",
      "m": "co_f_safety_city_vid_0_m",
      "src": "/pdf%20docs/Public%20Safety/KSA%20Testimonial%20Video.mp4"
    },
    {
      "t": "co_f_safety_city_vid_1_t",
      "m": "co_f_safety_city_vid_1_m"
    },
    {
      "t": "co_f_safety_city_vid_2_t",
      "m": "co_f_safety_city_vid_2_m"
    }
  ],
  "safety|city|broc": [
    {
      "t": "co_f_safety_city_broc_0_t",
      "m": "co_f_safety_city_broc_0_m",
      "src": "/pdf%20docs/Public%20Safety/Public%20Safety%20Brochure.pdf"
    },
    {
      "t": "co_f_safety_city_broc_1_t",
      "m": "co_f_safety_city_broc_1_m"
    }
  ],
  "safety|city|ppt": [
    {
      "t": "co_f_safety_city_ppt_0_t",
      "m": "co_f_safety_city_ppt_0_m",
      "src": "/pdf%20docs/Public%20Safety/Public%20Safety%20Deck.pdf"
    }
  ],
  "safety|city|case": [
    {
      "t": "co_f_safety_city_case_0_t",
      "m": "co_f_safety_city_case_0_m",
      "src": "/pdf%20docs/Public%20Safety/Public%20Safety_KSA_Case_Study.pdf"
    },
    {
      "t": "co_f_safety_city_case_1_t",
      "m": "co_f_safety_city_case_1_m",
      "src": "/pdf%20docs/Public%20Safety/Certificate%20of%20Achievement%20from%20MoMAH.pdf"
    }
  ],
  "safety|construction|vid": [
    {
      "t": "co_f_safety_construction_vid_0_t",
      "m": "co_f_safety_construction_vid_0_m"
    },
    {
      "t": "co_f_safety_construction_vid_1_t",
      "m": "co_f_safety_construction_vid_1_m"
    },
    {
      "t": "co_f_safety_construction_vid_2_t",
      "m": "co_f_safety_construction_vid_2_m"
    }
  ],
  "safety|construction|broc": [
    {
      "t": "co_f_safety_construction_broc_0_t",
      "m": "co_f_safety_construction_broc_0_m"
    }
  ],
  "safety|construction|ppt": [
    {
      "t": "co_f_safety_construction_ppt_0_t",
      "m": "co_f_safety_construction_ppt_0_m"
    }
  ],
  "safety|construction|case": [
    {
      "t": "co_f_safety_construction_case_0_t",
      "m": "co_f_safety_construction_case_0_m"
    }
  ],
  "safety|road|vid": [
    {
      "t": "co_f_safety_road_vid_0_t",
      "m": "co_f_safety_road_vid_0_m"
    },
    {
      "t": "co_f_safety_road_vid_1_t",
      "m": "co_f_safety_road_vid_1_m"
    }
  ],
  "safety|road|broc": [
    {
      "t": "co_f_safety_road_broc_0_t",
      "m": "co_f_safety_road_broc_0_m"
    }
  ],
  "safety|road|ppt": [
    {
      "t": "co_f_safety_road_ppt_0_t",
      "m": "co_f_safety_road_ppt_0_m",
      "src": "/pdf%20docs/Public%20Safety/Tollway_Deck.pdf"
    }
  ],
  "safety|road|case": [
    {
      "t": "co_f_safety_road_case_0_t",
      "m": "co_f_safety_road_case_0_m"
    }
  ],
  "hospitality|hotel|vid": [
    {
      "t": "co_f_hospitality_hotel_vid_0_t",
      "m": "co_f_hospitality_hotel_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/Hospitality/Pool%20with%20logo.mp4"
    },
    {
      "t": "co_f_hospitality_hotel_vid_1_t",
      "m": "co_f_hospitality_hotel_vid_1_m",
      "src": "/video/local/Zoho%20WorkDrive/Hospitality/Tray%20with%20logo%20.mp4"
    },
    {
      "t": "co_f_hospitality_hotel_vid_2_t",
      "m": "co_f_hospitality_hotel_vid_2_m",
      "src": "/video/local/Zoho%20WorkDrive/Hospitality/Snacks%20with%20logo%20.mp4"
    },
    {
      "t": "co_f_hospitality_hotel_vid_3_t",
      "m": "co_f_hospitality_hotel_vid_3_m",
      "src": "/video/local/Zoho%20WorkDrive/Hospitality/New%20water%20leak.mp4"
    }
  ],
  "hospitality|hotel|broc": [
    {
      "t": "co_f_hospitality_hotel_broc_0_t",
      "m": "co_f_hospitality_hotel_broc_0_m",
      "src": "/pdf%20docs/Hospitality/Vigil-for-Hotels-One-Pager.pdf"
    }
  ],
  "hospitality|hotel|ppt": [
    {
      "t": "co_f_hospitality_hotel_ppt_0_t",
      "m": "co_f_hospitality_hotel_ppt_0_m",
      "src": "/pdf%20docs/Hospitality/Vigil%20by%20CamCom%20%E2%80%94%20Standard%20Deck.pdf"
    }
  ],
  "hospitality|hotel|case": [
    {
      "t": "co_f_hospitality_hotel_case_0_t",
      "m": "co_f_hospitality_hotel_case_0_m"
    }
  ],
  "hospitality|airports|vid": [
    {
      "t": "co_f_hospitality_airports_vid_0_t",
      "m": "co_f_hospitality_airports_vid_0_m"
    },
    {
      "t": "co_f_hospitality_airports_vid_1_t",
      "m": "co_f_hospitality_airports_vid_1_m"
    }
  ],
  "hospitality|airports|broc": [
    {
      "t": "co_f_hospitality_airports_broc_0_t",
      "m": "co_f_hospitality_airports_broc_0_m"
    }
  ],
  "hospitality|airports|ppt": [
    {
      "t": "co_f_hospitality_airports_ppt_0_t",
      "m": "co_f_hospitality_airports_ppt_0_m"
    }
  ],
  "hospitality|airports|case": [
    {
      "t": "co_f_hospitality_airports_case_0_t",
      "m": "co_f_hospitality_airports_case_0_m"
    }
  ],
  "oem|paint|vid": [
    {
      "t": "co_f_oem_paint_vid_0_t",
      "m": "co_f_oem_paint_vid_0_m"
    },
    {
      "t": "co_f_oem_paint_vid_1_t",
      "m": "co_f_oem_paint_vid_1_m"
    },
    {
      "t": "co_f_oem_paint_vid_2_t",
      "m": "co_f_oem_paint_vid_2_m"
    }
  ],
  "oem|paint|broc": [
    {
      "t": "co_f_oem_paint_broc_0_t",
      "m": "co_f_oem_paint_broc_0_m"
    }
  ],
  "oem|paint|ppt": [
    {
      "t": "co_f_oem_paint_ppt_0_t",
      "m": "co_f_oem_paint_ppt_0_m",
      "src": "/pdf%20docs/OEM/Automotive_OEM_and_FLV_Deck.pdf"
    }
  ],
  "oem|paint|case": [
    {
      "t": "co_f_oem_paint_case_0_t",
      "m": "co_f_oem_paint_case_0_m",
      "src": "/pdf%20docs/OEM/Volvo%20Case%20Study.pdf"
    },
    {
      "t": "co_f_oem_paint_case_1_t",
      "m": "co_f_oem_paint_case_1_m",
      "src": "/pdf%20docs/OEM/TVS%20Case%20Study.pdf"
    }
  ],
  "oem|eol|vid": [
    {
      "t": "co_f_oem_eol_vid_0_t",
      "m": "co_f_oem_eol_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/OEM/CamCom%20Rig%20Video%2010.52.41%E2%80%AFAM.mp4"
    },
    {
      "t": "co_f_oem_eol_vid_1_t",
      "m": "co_f_oem_eol_vid_1_m",
      "src": "/video/local/Zoho%20WorkDrive/OEM/simulation_demo_video.mp4"
    }
  ],
  "oem|eol|broc": [
    {
      "t": "co_f_oem_eol_broc_0_t",
      "m": "co_f_oem_eol_broc_0_m"
    }
  ],
  "oem|eol|ppt": [
    {
      "t": "co_f_oem_eol_ppt_0_t",
      "m": "co_f_oem_eol_ppt_0_m"
    }
  ],
  "oem|eol|case": [
    {
      "t": "co_f_oem_eol_case_0_t",
      "m": "co_f_oem_eol_case_0_m"
    }
  ],
  "oem|component|vid": [
    {
      "t": "co_f_oem_component_vid_0_t",
      "m": "co_f_oem_component_vid_0_m"
    }
  ],
  "oem|component|broc": [
    {
      "t": "co_f_oem_component_broc_0_t",
      "m": "co_f_oem_component_broc_0_m"
    }
  ],
  "oem|component|ppt": [
    {
      "t": "co_f_oem_component_ppt_0_t",
      "m": "co_f_oem_component_ppt_0_m"
    }
  ],
  "oem|component|case": [
    {
      "t": "co_f_oem_component_case_0_t",
      "m": "co_f_oem_component_case_0_m"
    }
  ],
  "aftermarket|all|vid": [
    {
      "t": "co_f_aftermarket_all_vid_0_t",
      "m": "co_f_aftermarket_all_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/Aftermarket/Rig%20Deployment%20Video.mp4"
    }
  ],
  "aftermarket|all|broc": [
    {
      "t": "co_f_aftermarket_all_broc_0_t",
      "m": "co_f_aftermarket_all_broc_0_m"
    },
    {
      "t": "co_f_aftermarket_all_broc_1_t",
      "m": "co_f_aftermarket_all_broc_1_m"
    }
  ],
  "aftermarket|all|ppt": [
    {
      "t": "co_f_aftermarket_all_ppt_0_t",
      "m": "co_f_aftermarket_all_ppt_0_m"
    }
  ],
  "aftermarket|all|case": [
    {
      "t": "co_f_aftermarket_all_case_0_t",
      "m": "co_f_aftermarket_all_case_0_m"
    },
    {
      "t": "co_f_aftermarket_all_case_1_t",
      "m": "co_f_aftermarket_all_case_1_m"
    }
  ],
  "proof|voices|vid": [
    {
      "t": "co_f_proof_voices_vid_0_t",
      "m": "co_f_proof_voices_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/Customer%20Testimonials/BAGIC%20Video%20Message%20-%20A%20V%20Padmanabha.mp4"
    },
    {
      "t": "co_f_proof_voices_vid_1_t",
      "m": "co_f_proof_voices_vid_1_m",
      "src": "/video/local/Zoho%20WorkDrive/Customer%20Testimonials/Zurich%20-%20Camcom%207th.mp4"
    },
    {
      "t": "co_f_proof_voices_vid_2_t",
      "m": "co_f_proof_voices_vid_2_m",
      "src": "/video/local/Zoho%20WorkDrive/Customer%20Testimonials/Shri%20NitinJi%20Gadkari%20Byte%20On%20Team%20Camcom%2011.59.19%E2%80%AFAM.mp4"
    },
    {
      "t": "co_f_proof_voices_vid_3_t",
      "m": "co_f_proof_voices_vid_3_m",
      "src": "/video/local/Zoho%20WorkDrive/Customer%20Testimonials/Final%20Atul%20Testimonial%20Video.mp4"
    },
    {
      "t": "co_f_proof_voices_vid_4_t",
      "m": "co_f_proof_voices_vid_4_m",
      "src": "/video/local/Zoho%20WorkDrive/Customer%20Testimonials/Final%20Subhankar%20Dey%20Testimonial%20Video.mp4"
    }
  ],
  "proof|sectors|vid": [
    {
      "t": "co_f_proof_sectors_vid_0_t",
      "m": "co_f_proof_sectors_vid_0_m",
      "src": "/video/local/Zoho%20WorkDrive/Misc/Warehousing.mp4"
    },
    {
      "t": "co_f_proof_sectors_vid_1_t",
      "m": "co_f_proof_sectors_vid_1_m",
      "src": "/video/local/Zoho%20WorkDrive/Misc/90%20s%20Edit%20Version%20Aviation%20Launch.mp4"
    }
  ],
  "proof|sectors|ppt": [
    {
      "t": "co_f_proof_sectors_ppt_0_t",
      "m": "co_f_proof_sectors_ppt_0_m",
      "src": "/pdf%20docs/CamCom%20AI%20Corporate%20Deck.pdf"
    }
  ]
};

export const DASHBOARDS = {
  "insurance|motor": {
    "kpis": [
      {
        "v": "co_d_insurance_motor_k0_v",
        "l": "co_d_insurance_motor_k0_l",
        "d": "co_d_insurance_motor_k0_d"
      },
      {
        "v": "co_d_insurance_motor_k1_v",
        "l": "co_d_insurance_motor_k1_l",
        "d": "co_d_insurance_motor_k1_d"
      },
      {
        "v": "co_d_insurance_motor_k2_v",
        "l": "co_d_insurance_motor_k2_l",
        "d": null
      },
      {
        "v": "co_d_insurance_motor_k3_v",
        "l": "co_d_insurance_motor_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_insurance_motor_t_title",
      "sub": "co_d_insurance_motor_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        5100,
        5940,
        6780,
        7420,
        8900,
        9760,
        10580,
        12480
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_insurance_motor_b0_title",
        "sub": "co_d_insurance_motor_b0_sub",
        "rows": [
          {
            "n": "co_d_insurance_motor_b0_r0",
            "v": 6720
          },
          {
            "n": "co_d_insurance_motor_b0_r1",
            "v": 3880
          },
          {
            "n": "co_d_insurance_motor_b0_r2",
            "v": 1880
          }
        ]
      },
      {
        "title": "co_d_insurance_motor_b1_title",
        "sub": "co_d_insurance_motor_b1_sub",
        "rows": [
          {
            "n": "co_d_insurance_motor_b1_r0",
            "v": 3140
          },
          {
            "n": "co_d_insurance_motor_b1_r1",
            "v": 2410
          },
          {
            "n": "co_d_insurance_motor_b1_r2",
            "v": 1780
          },
          {
            "n": "co_d_insurance_motor_b1_r3",
            "v": 1290
          },
          {
            "n": "co_d_insurance_motor_b1_r4",
            "v": 980
          }
        ]
      }
    ]
  },
  "insurance|property": {
    "kpis": [
      {
        "v": "co_d_insurance_property_k0_v",
        "l": "co_d_insurance_property_k0_l",
        "d": "co_d_insurance_property_k0_d"
      },
      {
        "v": "co_d_insurance_property_k1_v",
        "l": "co_d_insurance_property_k1_l",
        "d": "co_d_insurance_property_k1_d"
      },
      {
        "v": "co_d_insurance_property_k2_v",
        "l": "co_d_insurance_property_k2_l",
        "d": null
      },
      {
        "v": "co_d_insurance_property_k3_v",
        "l": "co_d_insurance_property_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_insurance_property_t_title",
      "sub": "co_d_insurance_property_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        820,
        910,
        1080,
        1210,
        1390,
        1560,
        1780,
        1940
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_insurance_property_b0_title",
        "sub": "co_d_insurance_property_b0_sub",
        "rows": [
          {
            "n": "co_d_insurance_property_b0_r0",
            "v": 1160
          },
          {
            "n": "co_d_insurance_property_b0_r1",
            "v": 520
          },
          {
            "n": "co_d_insurance_property_b0_r2",
            "v": 260
          }
        ]
      },
      {
        "title": "co_d_insurance_property_b1_title",
        "sub": "co_d_insurance_property_b1_sub",
        "rows": [
          {
            "n": "co_d_insurance_property_b1_r0",
            "v": 640
          },
          {
            "n": "co_d_insurance_property_b1_r1",
            "v": 470
          },
          {
            "n": "co_d_insurance_property_b1_r2",
            "v": 390
          },
          {
            "n": "co_d_insurance_property_b1_r3",
            "v": 250
          },
          {
            "n": "co_d_insurance_property_b1_r4",
            "v": 190
          }
        ]
      }
    ]
  },
  "safety|city": {
    "kpis": [
      {
        "v": "co_d_safety_city_k0_v",
        "l": "co_d_safety_city_k0_l",
        "d": "co_d_safety_city_k0_d"
      },
      {
        "v": "co_d_safety_city_k1_v",
        "l": "co_d_safety_city_k1_l",
        "d": "co_d_safety_city_k1_d"
      },
      {
        "v": "co_d_safety_city_k2_v",
        "l": "co_d_safety_city_k2_l",
        "d": null
      },
      {
        "v": "co_d_safety_city_k3_v",
        "l": "co_d_safety_city_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_safety_city_t_title",
      "sub": "co_d_safety_city_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        3100,
        3680,
        4210,
        5040,
        5890,
        6320,
        7010,
        7480
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_safety_city_b0_title",
        "sub": "co_d_safety_city_b0_sub",
        "rows": [
          {
            "n": "co_d_safety_city_b0_r0",
            "v": 18400
          },
          {
            "n": "co_d_safety_city_b0_r1",
            "v": 9800
          },
          {
            "n": "co_d_safety_city_b0_r2",
            "v": 8100
          },
          {
            "n": "co_d_safety_city_b0_r3",
            "v": 7200
          },
          {
            "n": "co_d_safety_city_b0_r4",
            "v": 5420
          }
        ]
      },
      {
        "title": "co_d_safety_city_b1_title",
        "sub": "co_d_safety_city_b1_sub",
        "rows": [
          {
            "n": "co_d_safety_city_b1_r0",
            "v": 4.2
          },
          {
            "n": "co_d_safety_city_b1_r1",
            "v": 7.6
          },
          {
            "n": "co_d_safety_city_b1_r2",
            "v": 11.4
          }
        ]
      }
    ]
  },
  "safety|construction": {
    "kpis": [
      {
        "v": "co_d_safety_construction_k0_v",
        "l": "co_d_safety_construction_k0_l",
        "d": null
      },
      {
        "v": "co_d_safety_construction_k1_v",
        "l": "co_d_safety_construction_k1_l",
        "d": "co_d_safety_construction_k1_d"
      },
      {
        "v": "co_d_safety_construction_k2_v",
        "l": "co_d_safety_construction_k2_l",
        "d": null
      },
      {
        "v": "co_d_safety_construction_k3_v",
        "l": "co_d_safety_construction_k3_l",
        "d": "co_d_safety_construction_k3_d"
      }
    ],
    "trend": {
      "title": "co_d_safety_construction_t_title",
      "sub": "co_d_safety_construction_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        120,
        168,
        196,
        214,
        248,
        262,
        290,
        322
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_safety_construction_b0_title",
        "sub": "co_d_safety_construction_b0_sub",
        "rows": [
          {
            "n": "co_d_safety_construction_b0_r0",
            "v": 840
          },
          {
            "n": "co_d_safety_construction_b0_r1",
            "v": 460
          },
          {
            "n": "co_d_safety_construction_b0_r2",
            "v": 290
          },
          {
            "n": "co_d_safety_construction_b0_r3",
            "v": 250
          }
        ]
      },
      {
        "title": "co_d_safety_construction_b1_title",
        "sub": "co_d_safety_construction_b1_sub",
        "rows": [
          {
            "n": "co_d_safety_construction_b1_r0",
            "v": 980
          },
          {
            "n": "co_d_safety_construction_b1_r1",
            "v": 580
          },
          {
            "n": "co_d_safety_construction_b1_r2",
            "v": 280
          }
        ]
      }
    ]
  },
  "safety|road": {
    "kpis": [
      {
        "v": "co_d_safety_road_k0_v",
        "l": "co_d_safety_road_k0_l",
        "d": "co_d_safety_road_k0_d"
      },
      {
        "v": "co_d_safety_road_k1_v",
        "l": "co_d_safety_road_k1_l",
        "d": "co_d_safety_road_k1_d"
      },
      {
        "v": "co_d_safety_road_k2_v",
        "l": "co_d_safety_road_k2_l",
        "d": "co_d_safety_road_k2_d"
      },
      {
        "v": "co_d_safety_road_k3_v",
        "l": "co_d_safety_road_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_safety_road_t_title",
      "sub": "co_d_safety_road_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        640,
        720,
        810,
        960,
        1040,
        1120,
        1210,
        1286
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_safety_road_b0_title",
        "sub": "co_d_safety_road_b0_sub",
        "rows": [
          {
            "n": "co_d_safety_road_b0_r0",
            "v": 8900
          },
          {
            "n": "co_d_safety_road_b0_r1",
            "v": 5100
          },
          {
            "n": "co_d_safety_road_b0_r2",
            "v": 4200
          },
          {
            "n": "co_d_safety_road_b0_r3",
            "v": 2600
          },
          {
            "n": "co_d_safety_road_b0_r4",
            "v": 1610
          }
        ]
      },
      {
        "title": "co_d_safety_road_b1_title",
        "sub": "co_d_safety_road_b1_sub",
        "rows": [
          {
            "n": "co_d_safety_road_b1_r0",
            "v": 13100
          },
          {
            "n": "co_d_safety_road_b1_r1",
            "v": 6800
          },
          {
            "n": "co_d_safety_road_b1_r2",
            "v": 2510
          }
        ]
      }
    ]
  },
  "hospitality|hotel": {
    "kpis": [
      {
        "v": "co_d_hospitality_hotel_k0_v",
        "l": "co_d_hospitality_hotel_k0_l",
        "d": null
      },
      {
        "v": "co_d_hospitality_hotel_k1_v",
        "l": "co_d_hospitality_hotel_k1_l",
        "d": "co_d_hospitality_hotel_k1_d"
      },
      {
        "v": "co_d_hospitality_hotel_k2_v",
        "l": "co_d_hospitality_hotel_k2_l",
        "d": null
      },
      {
        "v": "co_d_hospitality_hotel_k3_v",
        "l": "co_d_hospitality_hotel_k3_l",
        "d": "co_d_hospitality_hotel_k3_d"
      }
    ],
    "trend": {
      "title": "co_d_hospitality_hotel_t_title",
      "sub": "co_d_hospitality_hotel_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        240,
        268,
        302,
        336,
        368,
        392,
        420,
        448
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_hospitality_hotel_b0_title",
        "sub": "co_d_hospitality_hotel_b0_sub",
        "rows": [
          {
            "n": "co_d_hospitality_hotel_b0_r0",
            "v": 1180
          },
          {
            "n": "co_d_hospitality_hotel_b0_r1",
            "v": 840
          },
          {
            "n": "co_d_hospitality_hotel_b0_r2",
            "v": 690
          },
          {
            "n": "co_d_hospitality_hotel_b0_r3",
            "v": 500
          }
        ]
      },
      {
        "title": "co_d_hospitality_hotel_b1_title",
        "sub": "co_d_hospitality_hotel_b1_sub",
        "rows": [
          {
            "n": "co_d_hospitality_hotel_b1_r0",
            "v": 980
          },
          {
            "n": "co_d_hospitality_hotel_b1_r1",
            "v": 760
          },
          {
            "n": "co_d_hospitality_hotel_b1_r2",
            "v": 720
          },
          {
            "n": "co_d_hospitality_hotel_b1_r3",
            "v": 750
          }
        ]
      }
    ]
  },
  "hospitality|airports": {
    "kpis": [
      {
        "v": "co_d_hospitality_airports_k0_v",
        "l": "co_d_hospitality_airports_k0_l",
        "d": null
      },
      {
        "v": "co_d_hospitality_airports_k1_v",
        "l": "co_d_hospitality_airports_k1_l",
        "d": "co_d_hospitality_airports_k1_d"
      },
      {
        "v": "co_d_hospitality_airports_k2_v",
        "l": "co_d_hospitality_airports_k2_l",
        "d": null
      },
      {
        "v": "co_d_hospitality_airports_k3_v",
        "l": "co_d_hospitality_airports_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_hospitality_airports_t_title",
      "sub": "co_d_hospitality_airports_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        820,
        910,
        1040,
        1120,
        1240,
        1310,
        1420,
        1480
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_hospitality_airports_b0_title",
        "sub": "co_d_hospitality_airports_b0_sub",
        "rows": [
          {
            "n": "co_d_hospitality_airports_b0_r0",
            "v": 4200
          },
          {
            "n": "co_d_hospitality_airports_b0_r1",
            "v": 2100
          },
          {
            "n": "co_d_hospitality_airports_b0_r2",
            "v": 1900
          },
          {
            "n": "co_d_hospitality_airports_b0_r3",
            "v": 1440
          }
        ]
      },
      {
        "title": "co_d_hospitality_airports_b1_title",
        "sub": "co_d_hospitality_airports_b1_sub",
        "rows": [
          {
            "n": "co_d_hospitality_airports_b1_r0",
            "v": 3600
          },
          {
            "n": "co_d_hospitality_airports_b1_r1",
            "v": 2600
          },
          {
            "n": "co_d_hospitality_airports_b1_r2",
            "v": 2100
          },
          {
            "n": "co_d_hospitality_airports_b1_r3",
            "v": 1340
          }
        ]
      }
    ]
  },
  "oem|paint": {
    "kpis": [
      {
        "v": "co_d_oem_paint_k0_v",
        "l": "co_d_oem_paint_k0_l",
        "d": "co_d_oem_paint_k0_d"
      },
      {
        "v": "co_d_oem_paint_k1_v",
        "l": "co_d_oem_paint_k1_l",
        "d": "co_d_oem_paint_k1_d"
      },
      {
        "v": "co_d_oem_paint_k2_v",
        "l": "co_d_oem_paint_k2_l",
        "d": "co_d_oem_paint_k2_d"
      },
      {
        "v": "co_d_oem_paint_k3_v",
        "l": "co_d_oem_paint_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_oem_paint_t_title",
      "sub": "co_d_oem_paint_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        9200,
        10400,
        11800,
        13100,
        14600,
        15900,
        16300,
        18240
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_oem_paint_b0_title",
        "sub": "co_d_oem_paint_b0_sub",
        "rows": [
          {
            "n": "co_d_oem_paint_b0_r0",
            "v": 8667
          },
          {
            "n": "co_d_oem_paint_b0_r1",
            "v": 1860
          },
          {
            "n": "co_d_oem_paint_b0_r2",
            "v": 940
          },
          {
            "n": "co_d_oem_paint_b0_r3",
            "v": 610
          },
          {
            "n": "co_d_oem_paint_b0_r4",
            "v": 430
          }
        ]
      },
      {
        "title": "co_d_oem_paint_b1_title",
        "sub": "co_d_oem_paint_b1_sub",
        "rows": [
          {
            "n": "co_d_oem_paint_b1_r0",
            "v": 6100
          },
          {
            "n": "co_d_oem_paint_b1_r1",
            "v": 5400
          },
          {
            "n": "co_d_oem_paint_b1_r2",
            "v": 4200
          },
          {
            "n": "co_d_oem_paint_b1_r3",
            "v": 2540
          }
        ]
      }
    ]
  },
  "oem|eol": {
    "kpis": [
      {
        "v": "co_d_oem_eol_k0_v",
        "l": "co_d_oem_eol_k0_l",
        "d": null
      },
      {
        "v": "co_d_oem_eol_k1_v",
        "l": "co_d_oem_eol_k1_l",
        "d": null
      },
      {
        "v": "co_d_oem_eol_k2_v",
        "l": "co_d_oem_eol_k2_l",
        "d": null
      },
      {
        "v": "co_d_oem_eol_k3_v",
        "l": "co_d_oem_eol_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_oem_eol_t_title",
      "sub": "co_d_oem_eol_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        7400,
        8200,
        9300,
        10600,
        11800,
        12900,
        13800,
        14900
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_oem_eol_b0_title",
        "sub": "co_d_oem_eol_b0_sub",
        "rows": [
          {
            "n": "co_d_oem_eol_b0_r0",
            "v": 6400
          },
          {
            "n": "co_d_oem_eol_b0_r1",
            "v": 3100
          },
          {
            "n": "co_d_oem_eol_b0_r2",
            "v": 1900
          },
          {
            "n": "co_d_oem_eol_b0_r3",
            "v": 980
          }
        ]
      },
      {
        "title": "co_d_oem_eol_b1_title",
        "sub": "co_d_oem_eol_b1_sub",
        "rows": [
          {
            "n": "co_d_oem_eol_b1_r0",
            "v": 5600
          },
          {
            "n": "co_d_oem_eol_b1_r1",
            "v": 4900
          },
          {
            "n": "co_d_oem_eol_b1_r2",
            "v": 4400
          }
        ]
      }
    ]
  },
  "oem|component": {
    "kpis": [
      {
        "v": "co_d_oem_component_k0_v",
        "l": "co_d_oem_component_k0_l",
        "d": null
      },
      {
        "v": "co_d_oem_component_k1_v",
        "l": "co_d_oem_component_k1_l",
        "d": null
      },
      {
        "v": "co_d_oem_component_k2_v",
        "l": "co_d_oem_component_k2_l",
        "d": null
      },
      {
        "v": "co_d_oem_component_k3_v",
        "l": "co_d_oem_component_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_oem_component_t_title",
      "sub": "co_d_oem_component_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        42000,
        48000,
        54000,
        61000,
        68000,
        74000,
        80000,
        86400
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_oem_component_b0_title",
        "sub": "co_d_oem_component_b0_sub",
        "rows": [
          {
            "n": "co_d_oem_component_b0_r0",
            "v": 38000
          },
          {
            "n": "co_d_oem_component_b0_r1",
            "v": 21000
          },
          {
            "n": "co_d_oem_component_b0_r2",
            "v": 15400
          },
          {
            "n": "co_d_oem_component_b0_r3",
            "v": 12000
          }
        ]
      },
      {
        "title": "co_d_oem_component_b1_title",
        "sub": "co_d_oem_component_b1_sub",
        "rows": [
          {
            "n": "co_d_oem_component_b1_r0",
            "v": 41000
          },
          {
            "n": "co_d_oem_component_b1_r1",
            "v": 28400
          },
          {
            "n": "co_d_oem_component_b1_r2",
            "v": 17000
          }
        ]
      }
    ]
  },
  "aftermarket|all": {
    "kpis": [
      {
        "v": "co_d_aftermarket_all_k0_v",
        "l": "co_d_aftermarket_all_k0_l",
        "d": "co_d_aftermarket_all_k0_d"
      },
      {
        "v": "co_d_aftermarket_all_k1_v",
        "l": "co_d_aftermarket_all_k1_l",
        "d": "co_d_aftermarket_all_k1_d"
      },
      {
        "v": "co_d_aftermarket_all_k2_v",
        "l": "co_d_aftermarket_all_k2_l",
        "d": null
      },
      {
        "v": "co_d_aftermarket_all_k3_v",
        "l": "co_d_aftermarket_all_k3_l",
        "d": null
      }
    ],
    "trend": {
      "title": "co_d_aftermarket_all_t_title",
      "sub": "co_d_aftermarket_all_t_sub",
      "labels": [
        "co_mon_feb",
        "co_mon_mar",
        "co_mon_apr",
        "co_mon_may",
        "co_mon_jun",
        "co_mon_jul",
        "co_mon_aug",
        "co_mon_sep"
      ],
      "values": [
        3100,
        3600,
        4200,
        4900,
        5600,
        6300,
        6800,
        7420
      ]
    },
    "breakdowns": [
      {
        "title": "co_d_aftermarket_all_b0_title",
        "sub": "co_d_aftermarket_all_b0_sub",
        "rows": [
          {
            "n": "co_d_aftermarket_all_b0_r0",
            "v": 3100
          },
          {
            "n": "co_d_aftermarket_all_b0_r1",
            "v": 2740
          },
          {
            "n": "co_d_aftermarket_all_b0_r2",
            "v": 1580
          }
        ]
      },
      {
        "title": "co_d_aftermarket_all_b1_title",
        "sub": "co_d_aftermarket_all_b1_sub",
        "rows": [
          {
            "n": "co_d_aftermarket_all_b1_r0",
            "v": 2100
          },
          {
            "n": "co_d_aftermarket_all_b1_r1",
            "v": 1640
          },
          {
            "n": "co_d_aftermarket_all_b1_r2",
            "v": 1290
          },
          {
            "n": "co_d_aftermarket_all_b1_r3",
            "v": 780
          }
        ]
      }
    ]
  }
};

export const CAPTURE = [
  {
    "t": "co_cap_img_t",
    "b": "co_cap_img_b"
  },
  {
    "t": "co_cap_vid_t",
    "b": "co_cap_vid_b"
  }
];

export const INSIDE = [
  {
    "tag": "co_in_0_tag",
    "h": "co_in_0_h",
    "s": "co_in_0_s"
  },
  {
    "tag": "co_in_1_tag",
    "h": "co_in_1_h",
    "s": "co_in_1_s"
  },
  {
    "tag": "co_in_2_tag",
    "h": "co_in_2_h",
    "s": "co_in_2_s"
  },
  {
    "tag": "co_in_3_tag",
    "h": "co_in_3_h",
    "s": "co_in_3_s"
  },
  {
    "tag": "co_in_4_tag",
    "h": "co_in_4_h",
    "s": "co_in_4_s"
  },
  {
    "tag": "co_in_5_tag",
    "h": "co_in_5_h",
    "s": "co_in_5_s"
  }
];
/* Is there anything behind this button?  Deliberately asks the CONTENT, not the status chip:
   a slot can be marked "ready" and still have nothing wired, and Present mode used to force
   every row live. Both flows import this so they cannot disagree about what is clickable. */
/* Every DASHBOARDS entry is illustrative — invented figures transcribed from the UI draft, not
   a live feed (F09). So the Dashboard button has nothing real behind it and stays disabled.
   When the first dashboard is wired to real data, make this a per-dashboard flag rather than
   flipping the whole constant. */
export const DASHBOARDS_ARE_LIVE = false;

export const slotHasContent = (v, u, slot) => {
  if (slot === "demo") return Boolean(u.d.demo && (u.d.demo.url || u.d.demo.capture));
  if (slot === "dash") return DASHBOARDS_ARE_LIVE && Boolean(DASHBOARDS[`${v.key}|${u.key}`]);
  return (FILES[`${v.key}|${u.key}|${slot}`] || []).some((f) => f.src);
};
export const fileHasContent = (f) => Boolean(f && f.src);

/* Deliverable rows for one use case, with what you can actually open at the top.
   SLOTS stays the canonical order and is preserved WITHIN each band, so the list never
   reshuffles arbitrarily — it only lifts the live rows above the dead ones:
     1. has real content        -> openable now
     2. no content, not n/a     -> planned, disabled
     3. n/a                     -> does not apply to this use case
   Both flows call this instead of mapping SLOTS directly. */
export const orderedSlots = (v, u) => {
  const band = (slot) => {
    if (u.d[slot].s === "na") return 2;
    return slotHasContent(v, u, slot) ? 0 : 1;
  };
  return SLOTS.map((slot, i) => ({ slot, i, band: band(slot) }))
    .sort((a, b) => a.band - b.band || a.i - b.i)
    .map((x) => x.slot);
};

/* A file entry's `src` is either a video or a document; the sheet renders them differently.
   Sources are URL-encoded, so test the path before any #fragment or ?query. */
export const isPdf = (src) => /\.pdf$/i.test(String(src || "").split(/[?#]/)[0]);

export const SLOTS = ["demo","dash","vid","broc","ppt","case"];

export const SLOT_LABEL = {
  "demo": "co_slot_demo",
  "dash": "co_slot_dash",
  "vid": "co_slot_vid",
  "broc": "co_slot_broc",
  "ppt": "co_slot_ppt",
  "case": "co_slot_case"
};

export const SLOT_MEDIA = {
  "demo": "co_media_demo",
  "dash": "co_media_dash",
  "vid": "co_media_vid",
  "broc": "co_media_broc",
  "ppt": "co_media_ppt",
  "case": "co_media_case"
};

export const STATUS_LABEL = {
  "ready": "co_status_ready",
  "upload": "co_status_upload",
  "update": "co_status_update",
  "build": "co_status_build",
  "tbd": "co_status_tbd",
  "na": "co_status_na"
};
